export const ACCOMMODATION_TYPES = [
  { id: 1, name: 'hotel', slug: 'hotel' },
  { id: 2, name: 'apartment', slug: 'apartment' },
  { id: 3, name: 'villa', slug: 'villa' },
  { id: 4, name: 'homes', slug: 'homes' },
  { id: 5, name: 'hostel', slug: 'hostel' },
  { id: 6, name: 'resort', slug: 'resort' },
  { id: 7, name: 'apthotel', slug: 'apthotel' },
]
